<template>
    <dialog-template
        width="400px"
        v-bind="$attrs"
        v-on="$listeners">
        <div class="content">
            <p>{{ content }}</p>
            <slot name="content"/>
        </div>
        <div class="img-wrap">
            <img class="qrcode" :src="qrCodeUrl" alt="小程序二维码">
        </div>
    </dialog-template>
</template>

<script lang='ts'>
export default {
    props: {
        qrCodeUrl: String,
        content: String
    }
}
</script>

<style lang="scss" scoped>
.content {

    p {
        line-height: 24px;
        color: #333;
    }
}

.img-wrap {
    width: 188px;
    height: 188px;
    margin: 20px auto 14px;
    text-align: center;

    img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }
}

::v-deep .el-dialog__title {
    color: #333;
}

::v-deep .el-dialog__body {
    padding: 10px 10px 14px !important;
}
</style>
